import * as React from 'react'
import I18n from '../../../../core/i18n'
import { adminService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  code: 'code',
  comment: 'comment',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('promotion', { scope: 'activerecord.models' }),
})

const AdminPromotionNew: React.FC<{}> = props => {
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdPromotion, flush } = await adminService.createPromotion(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/promotions'
  }, [])

  return (
    <AdminLayoutNew
      model="promotion"
      title={title}
      fields={FIELDS}
      indexLink="/admin/promotions"
      formItems={
        <>
          <InputText required={true} name="code" defaultValue="" label="Code" />
          <InputText required={false} name="comment" defaultValue="" label="Commnet" />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminPromotionNew
